import InputHandler from "./InputHandler";
import {MdDelete} from "react-icons/md";
import React from "react";
import {ButtonActionStyled, ExpCardStyled} from "../../../styled/Resume";
import {FaPlus} from "react-icons/fa6";
import {useTheme} from "../../UI/Theme/ThemeContext";


const ExperienceCard = (props)=> {
    const {
        workExpArray,
        handleWorkExpChange,
        handleDeleteExp,
        handleAddExp,


    } = props;
    const {themeName} = useTheme();

    return (
        <div className="expContainer">
            {
                workExpArray.map((info, index) => (
                    <ExpCardStyled key={info} theme={themeName}>
                        <div className="input">
                            <InputHandler
                                name="company"
                                id={info.company}
                                value={info.company}
                                type="experience"
                                label="Company Name"
                                required={true}
                                onChange={(event) => handleWorkExpChange(event, index)}
                            />
                            <div className="half">
                                <InputHandler
                                    name="position"
                                    id={info.position + index}
                                    value={info.position}
                                    type="experience"
                                    label="Position Held"
                                    required={true}
                                    onChange={(event) => handleWorkExpChange(event, index)}
                                />
                                <InputHandler
                                    name="industry"
                                    id={info.industry + index}
                                    value={info.industry}
                                    type="experience"
                                    label="Industry"
                                    required={true}
                                    onChange={(event) => handleWorkExpChange(event, index)}
                                />

                            </div>

                            <InputHandler
                                name="workLink"
                                id={info.workLink + index}
                                value={info.workLink}
                                type="experience"
                                label="Related Link"
                                onChange={(event) => handleWorkExpChange(event, index)}
                            />
                            <div className="half">
                                <InputHandler
                                    name="dateFrom"
                                    id={info.dateFrom + index}
                                    value={info.dateFrom}
                                    type="experience"
                                    label="From"
                                    onChange={(event) => handleWorkExpChange(event, index)}
                                />

                                <InputHandler
                                    name="dateTo"
                                    id={info.dateTo + index}
                                    value={info.dateTo}
                                    type="experience"
                                    label="To"
                                    disabled={info.currently}
                                    onChange={(event) => handleWorkExpChange(event, index)}
                                />

                            </div>

                        </div>
                        <span className="currently">
                                <InputHandler
                                    name="currently"
                                    id={info.currently + index}
                                    value={info.currently}
                                    type="checkbox"
                                    label="I currently work here"
                                    onChange={(event) => handleWorkExpChange(event, index)}
                                />
                            </span>
                        <ButtonActionStyled>
                            <span className="del" onClick={handleDeleteExp}> <MdDelete/> </span>
                            <span className="add" onClick={handleAddExp}> <FaPlus/> </span>
                        </ButtonActionStyled>

                    </ExpCardStyled>

                ))
            }
        </div>
    );
}

export default ExperienceCard;